export enum InfluencerActionTypes {
  API_RESPONSE_SUCCESS = "@@influencer/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@influencer/API_RESPONSE_ERROR",

  CREATE_INFLUENCER = "@@influencer/CREATE_INFLUENCER",
  GET_INFLUENCER = "@@influencer/GET_INFLUENCER",
  UPDATE_INFLUENCER = "@@influencer/UPDATE_INFLUENCER",
  DELETE_INFLUENCER = "@@influencer/DELETE_INFLUENCER",
  UPDATE_INFLUENCER_PASSWORD = "@@influencer/UPDATE_INFLUENCER_PASSWORD",

  GET_COUPON_REPORTS = "@@influencer/GET_COUPON_REPORTS",
  GET_COMMISION_REPORTS = "@@influencer/GET_COMMISION_REPORTS",

}
